module.exports = __webpack_public_path__ + "static/media/galerija_2017 (6).9db728c4.jpg";